import { RESET_TOKEN, TOKEN_RESPONSE } from '../actions/auth';

export default function auth(state = {}, { type, payload }) {
    switch (type) {
        case TOKEN_RESPONSE:
            return {
                ...state,
                accessToken: payload.access_token || payload.accessToken,
                expiresAt: payload.expireIn
            };
        case RESET_TOKEN:
            return {};
        default:
            return state;
    }
}
